import React from "react";
import { PaginationInterface } from "../Util/Interface";
import { defaultPageOptions } from "../Util/Constant";

export default function Classic({
  params,
  updateParams = () => undefined,
  paginationPlacement = "right",
  paginationWrapperClass = "",
  pageOptions = defaultPageOptions,
}: PaginationInterface) {
  return (
    <div
      className={`table__pagination ${paginationPlacement} ${paginationWrapperClass}`}
    >
      <div className="table__pagination-left">
        <span>Rows per page: </span>
        <select
          value={params?.per_page || 25}
          onChange={(e) =>
            updateParams({
              ...params,
              page: 1,
              per_page: parseInt(e.target.value),
            })
          }
        >
          {pageOptions?.map((item, index) => (
            <option key={index} value={item.value}>
              {item.value}
            </option>
          ))}
        </select>
      </div>
      <div className="table__pagination-right">
        <span>
          Page: <b>{params?.page || 1}</b> of{" "}
          {params?.total
            ? Math.ceil((params?.total || 0) / (params?.per_page || 25))
            : 1}
        </span>
        <button
          onClick={() =>
            updateParams({ ...params, page: (params?.page || 1) - 1 })
          }
          disabled={params?.page === 1}
          className="pagination__button previous"
        >
          Previous
        </button>
        <button
          onClick={() =>
            updateParams({ ...params, page: (params?.page || 1) + 1 })
          }
          disabled={
            params?.page ===
            Math.ceil((params?.total || 1) / (params?.per_page || 25))
          }
          className="pagination__button next"
        >
          Next
        </button>
      </div>
    </div>
  );
}
